import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, FormHelperText } from '@mui/material';
import { useGetShopCategoriesQuery } from '../../store/services/shopCategories';

interface CategorySelectProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

const CategorySelect: React.FC<CategorySelectProps> = ({ value, onChange, error }) => {
  const { data: categories, isLoading } = useGetShopCategoriesQuery(undefined, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
  });

  if (isLoading) {
    return <div>Loading categories...</div>;
  }

  return (
    <FormControl fullWidth error={!!error} margin="dense">
      <InputLabel id="category-select-label">Category</InputLabel>
      <Select
        labelId="category-select-label"
        id="category-select"
        value={value}
        label="Category"
        onChange={(e) => onChange(e.target.value as string)}
      >
        {categories?.map((category) => (
          <MenuItem key={category._id} value={category._id}>
            {category.name}
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default CategorySelect; 